import { render } from "./ClinicalExamDetail.vue?vue&type=template&id=34799d9e&scoped=true"
import script from "./ClinicalExamDetail.vue?vue&type=script&lang=js"
export * from "./ClinicalExamDetail.vue?vue&type=script&lang=js"

import "./ClinicalExamDetail.vue?vue&type=style&index=0&id=34799d9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34799d9e"]])

export default __exports__